<template>
  <div>
    <!-- <mark-create-dialog
      :student="student"
      :course="courseSelected"
      :state="createMarkDialog"
    ></mark-create-dialog> -->
    <v-data-table
      :headers="headers"
      :items="coursesList"
      :items-per-page="5"
      @click:row="showDetailMark"
      dense
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip label small :color="getColor(item.status)" dark>{{
          item.status | getStatus
        }}</v-chip>
      </template>
      <template v-slot:[`item.course`]="{ item }">
        <span>{{ item.title }}</span>
      </template>
      <template v-slot:[`item.classCode`]="{ item }">
        <span v-if="item.class">{{ getClass(item) }}</span>
      </template>
      <template v-slot:[`item.mark`]="{ item }">
        <span>{{ getMark(item.mark) }}</span>
      </template>
      <template
        v-slot:[`item.actions`]="{ item }"
        v-if="['education_manager', 'super_admin'].includes(role.type)"
      >
        <v-icon small class="mr-2" @click.stop="openCreateMarkDialog(item)">edit</v-icon>
      </template>
    </v-data-table>
    <student-mark-dialog :state="show" :mark="markDetail" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import StudentMarkDialog from '@/modules/student/mark/StudentMarkDialog.vue'
import _ from 'lodash'
export default {
  components: { StudentMarkDialog },
  props: {
    major: Object
  },
  data: () => ({
    show: false,
    markDetail: {},
    courseSelected: {},
    dialog: false,
    createMarkDialog: false,
    headers: [
      {
        text: 'Môn Học',
        align: 'left',
        sortable: false,
        value: 'course',
        width: '50%'
      },
      { text: 'Mã Môn', value: 'code', sortable: false, width: '10%' },
      { text: 'Mã Lớp', value: 'classCode', sortable: false, width: '20%' },
      { text: 'Điểm', value: 'mark', sortable: false, width: '10%' },
      {
        text: 'Trạng Thái',
        value: 'status',
        align: 'left',
        sortable: false,
        width: '10%'
      }
      // {
      //   text: 'Chấm điểm',
      //   value: 'actions',
      //   width: '5px',
      //   align: 'center',
      //   sortable: false
      // }
    ]
  }),
  computed: {
    ...mapState('app', ['department']),
    ...mapState('student', ['marks', 'classes']),
    ...mapState('auth', ['user', 'role']),
    ...mapGetters('student', ['student']),
    coursesList() {
      return this.major.courses.map(c => {
        const mark = _.get(this.marks, `${c.id}`, null)
        const clazz = _.get(this.classes, `${c.id}`, null)
        return {
          ...c,
          mark,
          class: clazz,
          status: this.getStatus(clazz, mark)
        }
      })
    },
    getHeaders() {
      if (['education_manager', 'super_admin'].includes(this.role.type)) return this.headers
      return this.headers.filter(header => header.value === 'actions')
    }
  },
  methods: {
    ...mapActions('student', ['fetchMarks']),
    openCreateMarkDialog(course) {
      this.createMarkDialog = !this.createMarkDialog
      this.courseSelected = course
    },
    getStatus: (clazz, mark) => {
      if (!mark || !mark.status) {
        if (clazz) {
          if (clazz.status === 'done') {
            return _.get(mark, 'value', 0) < 5 ? 'failed' : 'passed'
          } else {
            return 'learning'
          }
        } else {
          return ''
        }
      } else {
        return mark.status
      }
    },
    getMark: mark => {
      return mark ? mark.value : ''
    },
    getClass: course => {
      return _.get(course, 'class.code', '')
    },
    getColor: status => {
      if (status === 'learning') {
        return 'green'
      } else if (status === 'passed') {
        return 'primary'
      } else if (status === 'failed') {
        return 'red'
      } else return 'transparent'
    },
    showDetailMark(mark) {
      this.show = !this.show
      this.markDetail = mark.mark
    }
  },
  filters: {
    getStatus(status) {
      if (status === 'passed') {
        return 'Đỗ'
      } else if (status === 'failed') {
        return 'Trượt'
      } else if (status === 'learning') {
        return 'Đang học'
      } else {
        return ''
      }
    }
  }
}
</script>
